module.exports = __webpack_public_path__ + "static/media/hingeBottomImg1.2c1e901a.png";